<template>
  <div class="rules">
    <!-- <div class="headLabel">
      <p>{{content.chineseTitle}}</p>
      <p>{{content.englishTitle}}</p>
    </div> -->

  <div v-html="content.content">

  </div>

    <!-- <div v-for="(item, index) in list" :key="index">
      <template v-if="index == 0">
        <h4 class="headtitle">{{ $t("Guidanceunit") }}:</h4>
        <div class="boxs">{{item.guidanceUnit}}</div>

        <h4 class="headtitle">{{ $t("Organizers") }}:</h4>
        <div class="boxs">
          {{item.mainUnit}}
          
        </div>

        <h4 class="headtitle">{{ $t("CoOrganizer") }}:</h4>
        <div class="boxs">
           {{item.coOrganizer}}
          
          </div>

        <h4 class="headtitle">{{ $t("Organizer") }}:</h4>
        <div class="boxs"> {{item.organizer}}</div>

        <h4 class="headtitle">{{ $t("SupportUnits") }}:</h4>
        <div class="boxs">{{item.supportUnit}}</div>

        <h4 class="headtitle">{{ $t("Juries") }}:</h4>
        <div class="boxs">
          {{item.theJury}}
          
        </div>

        <h4 class="headtitle">{{ $t("SupportMedia") }}:</h4>
        <div class="boxs">
          {{item.supportMedia}}
          
        </div>

        <h4 class="headtitle">{{ $t("SelectionPurpose") }}:</h4>
        <div class="boxs">
          {{item.selectionPurpose}}
          
        </div>
      </template>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      obj: {},
      content:''
    };
  },
  created() {
    let lang = this.lang=='zh' ? 1:2;
    this.$getHttp("pc/tDesignAward/findAllDesignAward?language="+lang).then((res) => {
      if (res.success) {
        // this.list = res.DesignAwards;
        this.content=res.DesignAwards[0]
        console.log(this.content.content)
        // guidanceUnit
        // mainUnit
        // coOrganizer
        // organizer
        // supportUnit
        // theJury
        // supportMedia
        // selectionPurpose

        // res.DataDownload;
      } else {
        this.$message({
          message: res.msg,
        });
      }
    });
  },
};
</script>

<style lang="less" scoped>
.rules {
  text-align: left;
  margin-bottom: 32px;
  // h4 {
  //   position: relative;
  //   font-size: 26px;
  //   font-family: PingFang SC-Regular, PingFang SC;
  //   color: #333333;
  //   font-weight: 500;
  //   padding-left: 20px;
  //   margin-left: 5px;
  //   margin-top: 6px;
  //   margin-bottom: 25px;
  // }
  .headLabel {
    height: 112px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 50px;
    p {
      font-size: 40px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #6f73f4;
    }
  }
  // p {
  //   padding: 0 0 0 25px;
  //   font-size: 22px;
  //   font-family: PingFang SC-Regular, PingFang SC;
  //   font-weight: 400;
  //   color: #333333;
  //   line-height: 50px;
  //   margin-bottom: 15px;
  // }
}
</style>